// RoleHint — what a role allows, where a role is named beside a person and no
// link to the role can be followed (ADR-050 §2): the ⓘ button alone (the house
// pattern — `InfoPopover`), opening the shared read-only CapabilitySummary in a
// small panel (the family's Popover — a card on a desk, a sheet on a phone;
// never only a tooltip, ADR-080 §12). The person's PAGE names the role as the
// link to its peek instead — the peek carries the same summary. Reads the role's
// detail on its own (the roles' hook), so the user peek, the editor and the
// wizard's Access step say it the same way. Strings: the `roles` namespace.

import { useTranslation } from 'react-i18next';
import { useRole, useRoles } from '../../../hooks/useRoles.js';
import { InfoPopover } from '../../ui/InfoPopover.js';
import { CapabilitySummary } from './CapabilitySummary.js';
import { RoleDormantNarrowings, roleNarrowingSummary } from './roleNarrowings.js';

export interface RoleHintProps {
  projectId: string;
  roleId: number | null;
}

export function RoleHint({ projectId, roleId }: RoleHintProps) {
  const { t } = useTranslation('roles');
  const role = useRole(projectId, roleId);
  const allRoles = useRoles(projectId);
  if (roleId === null || !role.data) return null;
  const r = role.data;
  const availableRoles = (allRoles.data ?? []).map((x) => ({ id: x.id, name: x.name }));
  return (
    <InfoPopover label={t('hint.whatAllows')}>
      <div className="flex flex-col gap-3">
        <CapabilitySummary
          grants={r.permissions}
          narrowingSummary={roleNarrowingSummary(t, { managedRoles: r.managed_roles, availableRoles, responsibilityLevels: r.responsibility_levels })}
          emptyMessage={t('hint.nothing')}
        />
        <RoleDormantNarrowings grants={r.permissions} managedRoles={r.managed_roles} availableRoles={availableRoles} responsibilityLevels={r.responsibility_levels} />
      </div>
    </InfoPopover>
  );
}
